import { dashboardAccessGuard } from "@guards/dashboard-access.guard";
import { gobernanzaAccessGuard } from "@guards/gobernanza-access.guard";
import { typeStatesResolver } from "@resolvers/type-states.resolver";

import { type Routes } from "@angular/router";

export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    loadComponent: () => import("./modules/login/login.component"),
  },
  {
    path: "login/admin",
    loadComponent: () => import("./modules/admin-auth/admin-login.component"),
  },
  {
    path: "auth/admin/callback",
    loadComponent: () =>
      import("./modules/admin-auth/admin-callback.component"),
  },
  {
    path: "reset-password",
    loadComponent: () =>
      import("./modules/reset-password/reset-password.component"),
  },
  {
    path: "dashboard/:tenantId",
    canActivate: [dashboardAccessGuard],
    loadComponent: () => import("./modules/dashboard/dashboard.component"),
    loadChildren: () => import("./modules/dashboard/dashboard.routes"),
  },
  {
    path: "onboarding",
    loadComponent: () => import("./modules/onboarding/onboarding.component"),
    resolve: { typeStates: typeStatesResolver },
  },
  {
    path: "qrs/:tenantId/:section",
    loadComponent: () => import("./modules/qrs/qrs.component"),
  },
  {
    path: "landing-zone",
    loadComponent: () =>
      import("./modules/landing-zone/landing-zone.component"),
  },
  {
    path: "wsp-readings",
    loadComponent: () =>
      import("./modules/wsp-readings/wsp-readings.component"),
  },
  {
    path: "wsp-pressure-sensor",
    loadComponent: () =>
      import("./modules/wsp-pressure-sensor/wsp-pressure-sensor.component").then(
        m => m.WspPressureSensorComponent
      ),
  },
  {
    path: "wsp-estanque",
    loadComponent: () =>
      import("./modules/wsp-estanque/wsp-estanque.component").then(
        m => m.WspEstanqueComponent
      ),
  },
  {
    path: "login-gobernanza",
    loadComponent: () =>
      import("./modules/gobernanza/login-gobernanza.component"),
  },
  {
    path: "gobernanza",
    canActivate: [gobernanzaAccessGuard],
    loadComponent: () =>
      import("./modules/gobernanza/gobernanza-shell.component"),
  },
  {
    path: "pagos",
    loadComponent: () =>
      import("./modules/payments/payments-page/payments-page.component"),
  },
  {
    path: "no-access",
    loadComponent: () =>
      import("./modules/no-access/no-access.component").then(
        m => m.NoAccessComponent
      ),
  },
  {
    path: "plan-expired",
    loadComponent: () =>
      import("./modules/plan-expired/plan-expired.component"),
  },
  {
    path: "**",
    loadComponent: () =>
      import("./modules/not-found/not-found.component").then(
        m => m.NotFoundComponent
      ),
  },
];
